/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';
import {subCategoryPathSegment} from '../../../utils/companyCategorySubCategory';
import {reportTypeEnum} from '../../constants/enum';

const downloadReportAPI = async (
  selectedYear: string,
  reportType: reportTypeEnum,
  fileType: string = '',
  userId: string = ''
): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const companyID = useCompanyStore.getState().companyId;
  const companyDetails = useCompanyStore.getState().companyDetails;

  const reportURL = (type: reportTypeEnum) => {
    switch (type) {
      case reportTypeEnum.brsr:
        return `${API_ENDPOINT_JSON.ESG.downloadReport.brsrReport}`;
      case reportTypeEnum.ca:
        return `${API_ENDPOINT_JSON.ESG.downloadReport.caReport}`;
      case reportTypeEnum.gri:
        return '/gri/report';
      case reportTypeEnum.tcfd:
        return `${API_ENDPOINT_JSON.ESG.downloadReport.tcfdReport}`;
      case reportTypeEnum.cdp:
        return `${API_ENDPOINT_JSON.ESG.downloadReport.cdpReport}`;
      case reportTypeEnum.cdp_corporate:
        return `${API_ENDPOINT_JSON.ESG.downloadReport.cdpCorporateReport}`;
      default:
        throw new Error('Invalid report type');
    }
  };

  try {
    const response = await axios.request({
      method: CRUDMethods.GET,
      url:
        reportType === reportTypeEnum.tcfd
          ? `${API_BASE_URL}${reportURL(reportType)}/${companyID}/${
              subCategoryPathSegment(companyDetails.subCategory) ?? ''
            }/${selectedYear}/pdf/${userId}`
          : reportType === reportTypeEnum.cdp
            ? `${API_BASE_URL}${reportURL(
                reportType
              )}/${companyID}/${selectedYear}/pdf/${userId}`
            : `${API_BASE_URL}${reportURL(
                reportType
              )}/${companyID}/${selectedYear}/${fileType}/${userId}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });

    return response;
  } catch (err) {
    console.log('err:', err);
    throw err;
  }
};

export default downloadReportAPI;
